import { render } from "./SupplierGeneralInformationTab.vue?vue&type=template&id=9a7be85a&scoped=true"
import script from "./SupplierGeneralInformationTab.vue?vue&type=script&lang=js"
export * from "./SupplierGeneralInformationTab.vue?vue&type=script&lang=js"

import "./SupplierGeneralInformationTab.vue?vue&type=style&index=0&id=9a7be85a&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a7be85a"]])

export default __exports__